<template>
  <div v-if="!fetching" class="card-guide tourtrack-3">
    <div class="card-guide-body">
      <div class="d-flex justify-content-between">
        <span class="add-tracks" @click="showAddTrack">
          + Add Activation Track
        </span>
        <span class="search">
          <label>
            <svg
              width="16"
              height="17"
              viewBox="0 0 16 17"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M7.3335 3.16659C4.75617 3.16659 2.66683 5.25592 2.66683 7.83325C2.66683 10.4106 4.75617 12.4999 7.3335 12.4999C9.91083 12.4999 12.0002 10.4106 12.0002 7.83325C12.0002 5.25592 9.91083 3.16659 7.3335 3.16659ZM1.3335 7.83325C1.3335 4.51954 4.01979 1.83325 7.3335 1.83325C10.6472 1.83325 13.3335 4.51954 13.3335 7.83325C13.3335 11.147 10.6472 13.8333 7.3335 13.8333C4.01979 13.8333 1.3335 11.147 1.3335 7.83325Z"
                fill="#B3C2CB"
              />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M10.6284 11.1286C10.8887 10.8683 11.3108 10.8683 11.5712 11.1286L14.4712 14.0286C14.7315 14.289 14.7315 14.7111 14.4712 14.9714C14.2108 15.2318 13.7887 15.2318 13.5284 14.9714L10.6284 12.0714C10.368 11.8111 10.368 11.389 10.6284 11.1286Z"
                fill="#B3C2CB"
              />
            </svg>
            <input
              type="search"
              class="search-input"
              placeholder="Search Tracks"
              v-model="searchStr"
            />
          </label>
        </span>
      </div>

      <div class="tracks" role="tablist">
        <b-card no-body class="mb-1" v-for="(track, i) in tracks" :key="i">
          <b-card-header
            header-tag="header"
            :class="{ active: activeCollapse == 'track' + i }"
            role="tab"
            @click="getTrackStats($event, track)"
          >
            <b-button
              class="btn-collapse"
              block
              variant="collapse"
              v-b-toggle="'track' + i"
            >
              <span
                class="status-btn"
                :style="{ background: getStatusColor(track.status) }"
              >
                {{ getStatus(track.status) }}
              </span>
              {{ track.title }}
            </b-button>

            <span
              class="edit"
              @click="showEditTrack(i)"
              v-b-popover.top.hover="'Edit'"
              ><svg
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M2.6665 3.33333C2.48969 3.33333 2.32012 3.40357 2.1951 3.5286C2.07008 3.65362 1.99984 3.82319 1.99984 4V13.3333C1.99984 13.5101 2.07007 13.6797 2.1951 13.8047C2.32012 13.9298 2.48969 14 2.6665 14H11.9998C12.1766 14 12.3462 13.9298 12.4712 13.8047C12.5963 13.6797 12.6665 13.5101 12.6665 13.3333V9.77333C12.6665 9.40514 12.965 9.10667 13.3332 9.10667C13.7014 9.10667 13.9998 9.40514 13.9998 9.77333V13.3333C13.9998 13.8638 13.7891 14.3725 13.4141 14.7475C13.039 15.1226 12.5303 15.3333 11.9998 15.3333H2.6665C2.13607 15.3333 1.62736 15.1226 1.25229 14.7475C0.877218 14.3725 0.666504 13.8638 0.666504 13.3333V4C0.666504 3.46957 0.877217 2.96086 1.25229 2.58579C1.62736 2.21071 2.13607 2 2.6665 2H6.2265C6.59469 2 6.89317 2.29848 6.89317 2.66667C6.89317 3.03486 6.59469 3.33333 6.2265 3.33333H2.6665Z"
                  fill="#B3C2CB"
                />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M11.5284 0.86201C11.7888 0.601661 12.2109 0.601661 12.4712 0.86201L15.1379 3.52868C15.3983 3.78903 15.3983 4.21114 15.1379 4.47149L8.47124 11.1382C8.34622 11.2632 8.17665 11.3334 7.99984 11.3334H5.33317C4.96498 11.3334 4.6665 11.0349 4.6665 10.6667V8.00008C4.6665 7.82327 4.73674 7.6537 4.86177 7.52868L11.5284 0.86201ZM5.99984 8.27622V10.0001H7.7237L13.7237 4.00008L11.9998 2.27622L5.99984 8.27622Z"
                  fill="#B3C2CB"
                />
              </svg>
            </span>
            <span
              class="delete"
              @click="showDeleteTrack(i)"
              v-b-popover.top.hover="'Delete'"
            >
              <svg
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M1.3335 4.00008C1.3335 3.63189 1.63197 3.33341 2.00016 3.33341H14.0002C14.3684 3.33341 14.6668 3.63189 14.6668 4.00008C14.6668 4.36827 14.3684 4.66675 14.0002 4.66675H2.00016C1.63197 4.66675 1.3335 4.36827 1.3335 4.00008Z"
                  fill="#EF5C4A"
                />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M6.66683 2.00008C6.49002 2.00008 6.32045 2.07032 6.19543 2.19534C6.0704 2.32037 6.00016 2.48994 6.00016 2.66675V3.33341H10.0002V2.66675C10.0002 2.48994 9.92992 2.32037 9.8049 2.19534C9.67988 2.07032 9.51031 2.00008 9.3335 2.00008H6.66683ZM11.3335 3.33341V2.66675C11.3335 2.13631 11.1228 1.62761 10.7477 1.25253C10.3726 0.877462 9.86393 0.666748 9.3335 0.666748H6.66683C6.1364 0.666748 5.62769 0.877462 5.25262 1.25253C4.87754 1.62761 4.66683 2.13631 4.66683 2.66675V3.33341H3.3335C2.96531 3.33341 2.66683 3.63189 2.66683 4.00008V13.3334C2.66683 13.8638 2.87754 14.3726 3.25262 14.7476C3.62769 15.1227 4.1364 15.3334 4.66683 15.3334H11.3335C11.8639 15.3334 12.3726 15.1227 12.7477 14.7476C13.1228 14.3726 13.3335 13.8638 13.3335 13.3334V4.00008C13.3335 3.63189 13.035 3.33341 12.6668 3.33341H11.3335ZM4.00016 4.66675V13.3334C4.00016 13.5102 4.0704 13.6798 4.19543 13.8048C4.32045 13.9298 4.49002 14.0001 4.66683 14.0001H11.3335C11.5103 14.0001 11.6799 13.9298 11.8049 13.8048C11.9299 13.6798 12.0002 13.5102 12.0002 13.3334V4.66675H4.00016Z"
                  fill="#EF5C4A"
                />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M6.66683 6.66675C7.03502 6.66675 7.3335 6.96522 7.3335 7.33341V11.3334C7.3335 11.7016 7.03502 12.0001 6.66683 12.0001C6.29864 12.0001 6.00016 11.7016 6.00016 11.3334V7.33341C6.00016 6.96522 6.29864 6.66675 6.66683 6.66675Z"
                  fill="#EF5C4A"
                />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M9.3335 6.66675C9.70169 6.66675 10.0002 6.96522 10.0002 7.33341V11.3334C10.0002 11.7016 9.70169 12.0001 9.3335 12.0001C8.96531 12.0001 8.66683 11.7016 8.66683 11.3334V7.33341C8.66683 6.96522 8.96531 6.66675 9.3335 6.66675Z"
                  fill="#EF5C4A"
                />
              </svg>
            </span>
            <span class="chevron" v-b-toggle="'track' + i">
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M16.293 9.29297L12 13.586L7.70697 9.29297L6.29297 10.707L12 16.414L17.707 10.707L16.293 9.29297Z"
                  fill="#B3C2CB"
                />
              </svg>
            </span>
          </b-card-header>
          <b-collapse
            :id="'track' + i"
            accordion="my-accordion"
            role="tabpanel"
          >
            <b-card-body>
              <div class="row">
                <div class="col-1 ml-2" v-if="track.imgURL">
                  <span class="ico img-ico">
                    <img :src="track.imgURL" alt="" />
                  </span>
                </div>
                <div class="col-10 track-description">
                  <b-card-text
                    v-if="
                      track &&
                        track.detail &&
                        Object.keys(track.detail).length &&
                        track.detail[0] &&
                        track.detail[0].content
                    "
                    >{{
                      trimStr(track.detail[0].content[0].text, 50)
                    }}</b-card-text
                  >
                </div>
              </div>

              <!-- <div class="time">
                <svg
                  width="16"
                  height="17"
                  viewBox="0 0 16 17"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M7.99984 2.50008C4.68613 2.50008 1.99984 5.18637 1.99984 8.50008C1.99984 11.8138 4.68613 14.5001 7.99984 14.5001C11.3135 14.5001 13.9998 11.8138 13.9998 8.50008C13.9998 5.18637 11.3135 2.50008 7.99984 2.50008ZM0.666504 8.50008C0.666504 4.44999 3.94975 1.16675 7.99984 1.16675C12.0499 1.16675 15.3332 4.44999 15.3332 8.50008C15.3332 12.5502 12.0499 15.8334 7.99984 15.8334C3.94975 15.8334 0.666504 12.5502 0.666504 8.50008Z"
                    fill="var(--theme-color)"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M7.99984 3.83341C8.36803 3.83341 8.6665 4.13189 8.6665 4.50008V8.08806L10.9646 9.23713C11.294 9.40179 11.4274 9.80224 11.2628 10.1316C11.0981 10.4609 10.6977 10.5944 10.3684 10.4297L7.70169 9.09637C7.47584 8.98344 7.33317 8.7526 7.33317 8.50008V4.50008C7.33317 4.13189 7.63165 3.83341 7.99984 3.83341Z"
                    fill="var(--theme-color)"
                  />
                </svg>
                <span>{{ track.duration }} mins read</span>
              </div> -->

              <div class="track-foot">
                <div
                  v-if="track.status == 'active' && activeTrack"
                  class="stats"
                >
                  <span class="ico">
                    <svg
                      width="26"
                      height="16"
                      viewBox="0 0 26 16"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M5.90922 2.36355L3.54559 1.27264L1.36377 8.54536L3.54559 9.45445L3.85659 8.54536M5.90922 2.36355L3.85659 8.54536M5.90922 2.36355C6.39407 2.54537 7.69104 3.09082 9.00013 3.09082C10.3092 3.09082 11.9698 3.09082 12.6365 3.09082M3.85659 8.54536L5.18195 9.09082M5.18195 9.09082C5.36377 8.84839 5.87286 8.43627 6.45468 8.72718C7.0365 9.01809 7.06074 9.21203 7.00013 9.27264M5.18195 9.09082L4.81832 10.909C5.0155 11.1062 5.26743 11.3564 5.55146 11.6363M7.00013 9.27264C7.30316 9.15142 7.98195 8.98173 8.27286 9.27264C8.56377 9.56355 8.6365 10.1211 8.6365 10.3635M7.00013 9.27264L5.55146 11.6363M8.6365 10.3635C8.81832 10.3029 9.25468 10.2545 9.54559 10.5454C9.8365 10.8363 9.90922 11.3938 9.90922 11.6363M8.6365 10.3635L6.66909 12.7272M9.90922 11.6363C9.96983 11.6363 10.1638 11.709 10.4547 11.9999C10.7456 12.2908 10.8183 12.606 10.8183 12.7272C10.8183 12.9065 10.7586 13.2783 10.5508 13.6363M9.90922 11.6363L7.90922 13.9067M5.55146 11.6363C5.89101 11.9708 6.27644 12.3478 6.66909 12.7272M6.66909 12.7272C7.09005 13.1339 7.51932 13.5435 7.90922 13.9067M7.90922 13.9067C8.25401 14.2278 8.56803 14.5126 8.81832 14.7272C9.00013 14.909 9.72741 14.5454 10.2729 13.9999C10.3864 13.8864 10.4778 13.7622 10.5508 13.6363M18.4547 9.45445L12.4547 5.63627C11.6062 5.8787 9.80013 6.36355 9.36377 6.36355C8.81832 6.36355 8.45468 5.63627 8.45468 4.909C9.42438 4.30294 11.6183 3.09082 12.6365 3.09082M18.4547 9.45445C18.8183 9.45445 19.691 9.309 20.2729 8.72718C20.8547 8.14536 21.1594 7.63627 21.2391 7.45445M18.4547 9.45445C18.5759 9.9393 18.7456 10.9817 18.4547 11.2726C18.1638 11.5635 17.485 11.6363 17.182 11.6363M21.2391 7.45445L22.091 8.54536L24.4547 6.54536L20.2729 1.09082L17.7274 2.72718L17.9975 3.09082M21.2391 7.45445L17.9975 3.09082M17.9975 3.09082C17.5439 3.45446 16.4547 4.14536 15.7274 3.99991C14.8183 3.81809 13.9092 3.09082 12.6365 3.09082M17.182 11.6363C17.2426 11.9393 17.291 12.6181 17.0001 12.909C16.7092 13.1999 16.0304 13.1514 15.7274 13.0908M17.182 11.6363L13.182 8.54536M15.7274 13.0908C15.8486 13.3332 15.982 13.9272 15.5456 14.3635C15.1092 14.7999 14.1516 14.3029 13.7274 13.9999M15.7274 13.0908L12.2729 10.3635M13.7274 13.9999C13.788 14.1817 13.8001 14.6181 13.3638 14.909C12.6365 15.3938 11.3067 14.1817 10.5508 13.6363M13.7274 13.9999L11.5456 12.1817"
                        stroke="#8D99A0"
                      />
                    </svg>
                    {{
                      activeTrack.feedback &&
                        activeTrack.feedback.thankyous &&
                        activeTrack.feedback.thankyous.length
                    }}
                  </span>
                  <span class="ico">
                    <svg
                      width="19"
                      height="19"
                      viewBox="0 0 19 19"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M1 17.586L4.586 14H16C16.5304 14 17.0391 13.7893 17.4142 13.4142C17.7893 13.0391 18 12.5304 18 12V3C18 2.46957 17.7893 1.96086 17.4142 1.58579C17.0391 1.21071 16.5304 1 16 1H3C2.46957 1 1.96086 1.21071 1.58579 1.58579C1.21071 1.96086 1 2.46957 1 3V17.586ZM1 19H0V3C0 2.20435 0.316071 1.44129 0.87868 0.87868C1.44129 0.316071 2.20435 0 3 0H16C16.7956 0 17.5587 0.316071 18.1213 0.87868C18.6839 1.44129 19 2.20435 19 3V12C19 12.7957 18.6839 13.5587 18.1213 14.1213C17.5587 14.6839 16.7956 15 16 15H5L1 19Z"
                        fill="#8D99A0"
                      />
                    </svg>
                    {{
                      activeTrack.feedback &&
                        activeTrack.feedback.feedback.length
                    }}
                  </span>
                  <span class="ico">
                    <svg
                      width="14"
                      height="18"
                      viewBox="0 0 14 18"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M3 0H11C11.7957 0 12.5587 0.316071 13.1213 0.87868C13.6839 1.44129 14 2.20435 14 3V18L7 15L0 18V3C0 2.20435 0.316071 1.44129 0.87868 0.87868C1.44129 0.316071 2.20435 0 3 0ZM3 1C2.46957 1 1.96086 1.21071 1.58579 1.58579C1.21071 1.96086 1 2.46957 1 3V16.49L7 13.942L13 16.489V3C13 2.46957 12.7893 1.96086 12.4142 1.58579C12.0391 1.21071 11.5304 1 11 1H3Z"
                        fill="#8D99A0"
                      />
                    </svg>
                    {{
                      activeTrack.feedback &&
                        activeTrack.feedback.bookmarks.length
                    }}
                  </span>
                  <span class="ico">
                    <svg
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M22.4131 11.6862C20.1665 7.53286 16.2265 5.01953 11.8665 5.01953C7.50648 5.01953 3.55982 7.53286 1.33315 11.6862L1.14648 11.9995L1.31982 12.3195C3.56648 16.4729 7.50648 18.9862 11.8665 18.9862C16.2265 18.9862 20.1731 16.5062 22.4131 12.3195L22.5865 11.9995L22.4131 11.6862ZM11.8665 17.6195C8.11315 17.6195 4.66648 15.5262 2.66648 11.9995C4.66648 8.47286 8.11315 6.37953 11.8665 6.37953C15.6198 6.37953 19.0265 8.47953 21.0598 11.9995C19.0265 15.5262 15.6131 17.6195 11.8665 17.6195Z"
                        fill="#8D99A0"
                      />
                      <path
                        d="M12.06 7.44641C11.1561 7.45301 10.2744 7.72733 9.52626 8.23473C8.77815 8.74213 8.19719 9.45985 7.85676 10.2972C7.51632 11.1346 7.43167 12.0541 7.61351 12.9396C7.79534 13.8251 8.23551 14.6368 8.8784 15.2722C9.5213 15.9077 10.3381 16.3384 11.2256 16.5099C12.1131 16.6814 13.0316 16.586 13.865 16.2359C14.6983 15.8857 15.4092 15.2964 15.9079 14.5425C16.4065 13.7885 16.6706 12.9037 16.6666 11.9997C16.664 11.398 16.5427 10.8028 16.3096 10.248C16.0765 9.69329 15.7363 9.19001 15.3083 8.76701C14.8804 8.34402 14.3731 8.00964 13.8157 7.78302C13.2583 7.55641 12.6617 7.44202 12.06 7.44641ZM12.06 15.2597C11.4215 15.2532 10.7992 15.0581 10.2712 14.699C9.74321 14.3398 9.33311 13.8327 9.09241 13.2413C8.8517 12.6499 8.79111 12.0005 8.91825 11.3748C9.0454 10.749 9.3546 10.1748 9.80703 9.72422C10.2595 9.27363 10.8349 8.96678 11.4612 8.84219C12.0875 8.7176 12.7366 8.78084 13.327 9.02396C13.9174 9.26708 14.4229 9.67924 14.7798 10.2087C15.1368 10.7381 15.3293 11.3612 15.3333 11.9997C15.3351 12.4295 15.2515 12.8553 15.0875 13.2525C14.9235 13.6497 14.6822 14.0104 14.3777 14.3136C14.0732 14.6169 13.7116 14.8566 13.3137 15.0191C12.9158 15.1815 12.4897 15.2633 12.06 15.2597Z"
                        fill="#8D99A0"
                      />
                    </svg>
                    {{
                      activeTrack.feedback && activeTrack.feedback.views.length
                    }}
                  </span>
                </div>
                <span v-else></span>
                <div class="collapse-foot">
                  <!-- <b-button
                    class="upload-btn"
                    @click="handleAudioClick(track)"
                    :disabled="track.status !== 'active'"
                  >
                    <span class="ico">
                      <svg
                        width="16"
                        height="17"
                        viewBox="0 0 16 17"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <g clip-path="url(#clip0)">
                          <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M6.11454 1.28105C6.61464 0.780951 7.29292 0.5 8.00016 0.5C8.70741 0.5 9.38568 0.780951 9.88578 1.28105C10.3859 1.78115 10.6668 2.45942 10.6668 3.16667V8.5C10.6668 9.20724 10.3859 9.88552 9.88578 10.3856C9.38568 10.8857 8.70741 11.1667 8.00016 11.1667C7.29292 11.1667 6.61464 10.8857 6.11454 10.3856C5.61445 9.88552 5.3335 9.20724 5.3335 8.5V3.16667C5.3335 2.45942 5.61445 1.78115 6.11454 1.28105ZM8.00016 1.83333C7.64654 1.83333 7.3074 1.97381 7.05735 2.22386C6.80731 2.47391 6.66683 2.81304 6.66683 3.16667V8.5C6.66683 8.85362 6.80731 9.19276 7.05735 9.44281C7.3074 9.69286 7.64654 9.83333 8.00016 9.83333C8.35379 9.83333 8.69292 9.69286 8.94297 9.44281C9.19302 9.19276 9.3335 8.85362 9.3335 8.5V3.16667C9.3335 2.81304 9.19302 2.47391 8.94297 2.22386C8.69292 1.97381 8.35379 1.83333 8.00016 1.83333Z"
                            fill="var(--theme-color)"
                          />
                          <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M3.33317 6.5C3.70136 6.5 3.99984 6.79848 3.99984 7.16667V8.5C3.99984 9.56087 4.42126 10.5783 5.17141 11.3284C5.92156 12.0786 6.93897 12.5 7.99984 12.5C9.0607 12.5 10.0781 12.0786 10.8283 11.3284C11.5784 10.5783 11.9998 9.56087 11.9998 8.5V7.16667C11.9998 6.79848 12.2983 6.5 12.6665 6.5C13.0347 6.5 13.3332 6.79848 13.3332 7.16667V8.5C13.3332 9.91449 12.7713 11.271 11.7711 12.2712C10.7709 13.2714 9.41432 13.8333 7.99984 13.8333C6.58535 13.8333 5.22879 13.2714 4.2286 12.2712C3.22841 11.271 2.6665 9.91449 2.6665 8.5V7.16667C2.6665 6.79848 2.96498 6.5 3.33317 6.5Z"
                            fill="var(--theme-color)"
                          />
                          <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M8.00016 12.5C8.36835 12.5 8.66683 12.7985 8.66683 13.1667V15.8333C8.66683 16.2015 8.36835 16.5 8.00016 16.5C7.63197 16.5 7.3335 16.2015 7.3335 15.8333V13.1667C7.3335 12.7985 7.63197 12.5 8.00016 12.5Z"
                            fill="var(--theme-color)"
                          />
                          <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M4.6665 15.8337C4.6665 15.4655 4.96498 15.167 5.33317 15.167H10.6665C11.0347 15.167 11.3332 15.4655 11.3332 15.8337C11.3332 16.2018 11.0347 16.5003 10.6665 16.5003H5.33317C4.96498 16.5003 4.6665 16.2018 4.6665 15.8337Z"
                            fill="var(--theme-color)"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0">
                            <rect
                              width="16"
                              height="16"
                              fill="white"
                              transform="translate(0 0.5)"
                            />
                          </clipPath>
                        </defs>
                      </svg>
                    </span>
                    <span class="ml-1">Add Audio</span>
                  </b-button> -->
                  <b-button
                    class="upload-btn"
                    @click="handleViewClick(track, i)"
                  >
                    <span class="content">
                      <span class="ico"
                        ><svg
                          version="1.1"
                          id="Layer_1"
                          x="0px"
                          y="0px"
                          viewBox="0 0 489.347 489.347"
                          fill="var(--theme-color)"
                          width="16"
                          height="16"
                        >
                          <g>
                            <path
                              d="M412.642,345.939l-59.523-14.229l-66.352-66.352l51.12-51.055c11.874,4.167,24.216,6.203,36.499,6.202
		c28.736-0.002,57.122-11.149,78.233-32.221c32.686-32.626,41.544-82.646,22.043-124.466l-9.042-19.391l-53.807,53.682
		l-24.986-24.941l53.822-53.696L421.17,10.42C379.3-9.036,329.218-0.195,296.546,32.417
		c-30.131,30.078-40.012,74.943-26.092,114.534l-20.111,20.086L102.13,18.837C91.061,7.731,76.32,1.605,60.621,1.587
		c-0.023,0-0.044,0-0.067,0c-15.696,0-30.45,6.104-41.553,17.195C7.886,29.897,1.77,44.669,1.778,60.378
		c0.008,15.697,6.129,30.456,17.233,41.553L167.18,250.094l-20.155,20.129c-39.652-13.917-84.597-4.061-114.733,26.02
		C-0.393,328.869-9.252,378.888,10.25,420.708l9.042,19.391l53.806-53.681l24.986,24.94l-53.822,53.697l19.48,9.051
		c14.814,6.883,30.652,10.224,46.388,10.224c28.738-0.001,57.124-11.148,78.235-32.221c30.132-30.078,40.013-74.943,26.093-114.534
		l51.082-51.018l66.366,66.366l14.229,59.523l76.705,76.706l66.507-66.507L412.642,345.939z M301.691,144.194
		c-14.181-30.419-7.73-66.807,16.05-90.545c18.28-18.246,44.036-26.278,68.827-22.6l-42.211,42.113l67.451,67.328l42.24-42.142
		c3.697,24.738-4.343,50.456-22.622,68.702c-23.802,23.759-60.288,30.197-90.793,16.02l-9.505-4.417l-34.603,34.559l-24.968-24.965
		l34.573-34.529L301.691,144.194z M31.778,60.362c-0.004-7.69,2.992-14.923,8.43-20.362c5.433-5.426,12.657-8.414,20.347-8.414
		c7.711,0.009,14.918,3.002,20.345,8.446l194.398,194.38l-40.711,40.659L40.221,80.714C34.781,75.277,31.782,68.049,31.778,60.362z
		 M167.171,430.877c-18.28,18.246-44.038,26.278-68.827,22.6l42.211-42.112l-67.451-67.329l-42.24,42.142
		c-3.698-24.737,4.343-50.455,22.623-68.702c23.801-23.758,60.288-30.197,90.792-16.021l9.505,4.417l34.609-34.565l24.967,24.966
		l-34.578,34.534l4.44,9.525C197.403,370.751,190.952,407.138,167.171,430.877z M373.342,397.227l-7.564-31.645l31.646,7.564
		l49.498,49.499l-24.081,24.081L373.342,397.227z"
                            />
                          </g></svg
                      ></span>
                      <span class="btn-content">Tools</span>
                    </span>
                  </b-button>
                  <b-button
                    class="upload-btn"
                    @click="uploadScreen(i)"
                    :disabled="track.status == 'active'"
                  >
                    <span class="content">
                      <span
                        class="ico img-ico"
                        v-if="track.imgURL && !uploadingScreen"
                      >
                        <img :src="track.imgURL" alt="" />
                      </span>
                      <span
                        v-if="!track.imgURL && !uploadingScreen"
                        class="ico img-ico"
                      >
                        <svg
                          width="16"
                          height="16"
                          viewBox="0 0 16 16"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M3.33301 2.66634C2.96482 2.66634 2.66634 2.96482 2.66634 3.33301V12.6663C2.66634 13.0345 2.96482 13.333 3.33301 13.333H12.6663C13.0345 13.333 13.333 13.0345 13.333 12.6663V3.33301C13.333 2.96482 13.0345 2.66634 12.6663 2.66634H3.33301ZM1.33301 3.33301C1.33301 2.22844 2.22844 1.33301 3.33301 1.33301H12.6663C13.7709 1.33301 14.6663 2.22844 14.6663 3.33301V12.6663C14.6663 13.7709 13.7709 14.6663 12.6663 14.6663H3.33301C2.22844 14.6663 1.33301 13.7709 1.33301 12.6663V3.33301Z"
                            fill="var(--theme-color)"
                          />
                          <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M5.66634 5.33301C5.48225 5.33301 5.33301 5.48225 5.33301 5.66634C5.33301 5.85044 5.48225 5.99967 5.66634 5.99967C5.85044 5.99967 5.99967 5.85044 5.99967 5.66634C5.99967 5.48225 5.85044 5.33301 5.66634 5.33301ZM3.99967 5.66634C3.99967 4.74587 4.74587 3.99967 5.66634 3.99967C6.58682 3.99967 7.33301 4.74587 7.33301 5.66634C7.33301 6.58682 6.58682 7.33301 5.66634 7.33301C4.74587 7.33301 3.99967 6.58682 3.99967 5.66634Z"
                            fill="var(--theme-color)"
                          />
                          <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M10.1949 6.19494C10.4553 5.93459 10.8774 5.93459 11.1377 6.19494L14.4711 9.52827C14.7314 9.78862 14.7314 10.2107 14.4711 10.4711C14.2107 10.7314 13.7886 10.7314 13.5283 10.4711L10.6663 7.60915L3.80441 14.4711C3.54406 14.7314 3.12195 14.7314 2.8616 14.4711C2.60125 14.2107 2.60125 13.7886 2.8616 13.5283L10.1949 6.19494Z"
                            fill="var(--theme-color)"
                          />
                        </svg>
                      </span>
                      <span class="btn-content" v-if="uploadingScreen">
                        <b-spinner small></b-spinner>
                      </span>
                      <span v-else class="btn-content">
                        Add Image
                      </span>
                    </span>
                  </b-button>
                  <b-button
                    class="upload-btn"
                    @click="handleVideoClick(track)"
                    :disabled="
                      track.status !== 'active' ||
                        (!track.video && uploadingVideo)
                    "
                  >
                    <span class="content">
                      <span
                        class="ico"
                        v-if="!uploadingVideo && !processingVideo"
                      >
                        <svg
                          width="21"
                          height="20"
                          viewBox="0 0 21 20"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <g clip-path="url(#clip0)">
                            <path
                              fill-rule="evenodd"
                              clip-rule="evenodd"
                              d="M20.048 5.09236C20.3255 5.2352 20.5 5.52118 20.5 5.83334V14.1667C20.5 14.4788 20.3255 14.7648 20.048 14.9076C19.7704 15.0505 19.4363 15.0262 19.1823 14.8448L13.349 10.6781C13.13 10.5217 13 10.2691 13 10C13 9.73088 13.13 9.47832 13.349 9.32189L19.1823 5.15523C19.4363 4.97379 19.7704 4.94953 20.048 5.09236ZM15.2671 10L18.8333 12.5473V7.45266L15.2671 10Z"
                              fill="var(--theme-color)"
                            />
                            <path
                              fill-rule="evenodd"
                              clip-rule="evenodd"
                              d="M3 4.99967C2.53976 4.99967 2.16667 5.37277 2.16667 5.83301V14.1663C2.16667 14.6266 2.53976 14.9997 3 14.9997H12.1667C12.6269 14.9997 13 14.6266 13 14.1663V5.83301C13 5.37277 12.6269 4.99967 12.1667 4.99967H3ZM0.5 5.83301C0.5 4.4523 1.61929 3.33301 3 3.33301H12.1667C13.5474 3.33301 14.6667 4.4523 14.6667 5.83301V14.1663C14.6667 15.5471 13.5474 16.6663 12.1667 16.6663H3C1.61929 16.6663 0.5 15.5471 0.5 14.1663V5.83301Z"
                              fill="var(--theme-color)"
                            />
                          </g>
                          <defs>
                            <clipPath id="clip0">
                              <rect
                                width="20"
                                height="20"
                                fill="white"
                                transform="translate(0.5)"
                              />
                            </clipPath>
                          </defs>
                        </svg>
                      </span>
                      <span
                        class="btn-content"
                        v-if="
                          !track.video && !uploadingVideo && !processingVideo
                        "
                      >
                        Add Video
                        <input
                          id="blogger-track-video"
                          type="file"
                          style="visibility: hidden"
                          @change="uploadBloggerTrackVideo"
                        />
                      </span>
                      <span
                        class="btn-content"
                        v-if="
                          uploadingVideo &&
                            !track.video &&
                            selectedTrack.id == track.id
                        "
                      >
                        <b-spinner small></b-spinner>
                        Uploading {{ progress }}%
                      </span>
                      <span
                        class="btn-content"
                        v-if="
                          processingVideo &&
                            (!track.video || !track.video.videoThumb) &&
                            selectedTrack.id == track.id
                        "
                      >
                        <b-spinner small></b-spinner>
                        Processing
                      </span>
                      <span
                        class="watch-video"
                        v-if="
                          track.video &&
                            track.video.videoId &&
                            track.video.videoThumb
                        "
                      >
                        Video
                      </span>
                    </span>
                  </b-button>
                  <b-button
                    class="btn-simple-primary btn-start"
                    @click="submitTrack(track)"
                    :disabled="
                      track.status == 'submitted' ||
                        track.status == 'active' ||
                        track.status == 'inactive'
                    "
                  >
                    Submit Track
                  </b-button>
                </div>
              </div>
            </b-card-body>
          </b-collapse>
        </b-card>
      </div>
      <my-upload
        langType="en"
        field="img"
        @crop-success="cropSuccess"
        @crop-upload-success="cropUploadSuccess"
        @crop-upload-fail="cropUploadFail"
        v-model="showUpload"
        :width="300"
        :height="300"
        :params="params"
        :headers="headers"
        img-format="png"
        :noSquare="true"
        ref="myupload"
      >
      </my-upload>
      <modal :id="trackModal">
        <div class="add-track" v-if="!del">
          <span class="close-icon" @click="cancelAction">
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle cx="12" cy="12" r="12" fill="#E4E6EB" />
              <g clip-path="url(#clip0)">
                <path
                  d="M12.5891 12.0006L17.2111 7.37855C17.3739 7.21582 17.3739 6.95199 17.2111 6.78928C17.0484 6.62657 16.7846 6.62655 16.6219 6.78928L11.9998 11.4113L7.37782 6.78928C7.21509 6.62655 6.95126 6.62655 6.78855 6.78928C6.62584 6.95201 6.62582 7.21584 6.78855 7.37855L11.4106 12.0006L6.78855 16.6226C6.62582 16.7853 6.62582 17.0492 6.78855 17.2119C6.8699 17.2932 6.97655 17.3339 7.0832 17.3339C7.18984 17.3339 7.29647 17.2932 7.37784 17.2119L11.9998 12.5899L16.6218 17.2119C16.7032 17.2932 16.8098 17.3339 16.9165 17.3339C17.0231 17.3339 17.1298 17.2932 17.2111 17.2119C17.3739 17.0491 17.3739 16.7853 17.2111 16.6226L12.5891 12.0006Z"
                  fill="#606770"
                />
              </g>
              <defs>
                <clipPath id="clip0">
                  <rect
                    width="10.6667"
                    height="10.6667"
                    fill="white"
                    transform="translate(6.6665 6.66675)"
                  />
                </clipPath>
              </defs>
            </svg>
          </span>

          <h3>{{ add ? "Create" : "Edit" }} Track</h3>
          <div class="h-18"></div>
          <b-form-group label="Title">
            <b-form-input
              type="text"
              required
              v-model="track.title"
              placeholder="Enter your track title here"
              :disabled="
                activeTrackStatus == 'active' ||
                  activeTrackStatus == 'inactive' ||
                  activeTrackStatus == 'submitted'
              "
            ></b-form-input>
          </b-form-group>
          <!-- <b-form-group class="textarea-scroll" label="Description">
            <b-form-textarea
              id="textarea-default"
              rows="3"
              no-resize
              v-model="track.detail"
              placeholder="Enter your track detail here"
              :disabled="
                activeTrackStatus == 'active' ||
                  activeTrackStatus == 'inactive' ||
                  activeTrackStatus == 'submitted'
              "
            ></b-form-textarea>
          </b-form-group> -->
          <span class="description-title">
            <!-- {{ editMode ? "Edit" : "Add" }} description here -->
          </span>
          <transition name="fadeHeight" mode="out-in">
            <Editor
              id="textarea-default"
              v-show="true"
              @input="input"
              :clear="clear"
              :currentJourneyContent="trackContent"
              @resetClear="resetClear"
            />
          </transition>
          <b-form-row class="half-fields">
            <b-form-group label="Weeks" class="mr-5">
              <b-form-input
                type="number"
                required
                v-model.number="track.weeks"
                @change="getNumWeek"
                placeholder="Add your track weeks in numbers"
                :disabled="
                  activeTrackStatus == 'active' ||
                    activeTrackStatus == 'inactive' ||
                    activeTrackStatus == 'submitted'
                "
              ></b-form-input>
            </b-form-group>

            <b-form-group label="Price $">
              <b-form-input
                type="number"
                required
                v-model.number="track.price"
                placeholder="Add price of activation track"
                :disabled="
                  activeTrackStatus == 'active' ||
                    activeTrackStatus == 'inactive' ||
                    activeTrackStatus == 'submitted'
                "
              ></b-form-input>
            </b-form-group>
            <b-form-group label="Category" class="mr-5">
              <b-form-input
                type="text"
                required
                v-model.number="track.categories"
                placeholder="Add category"
                :disabled="
                  activeTrackStatus == 'active' ||
                    activeTrackStatus == 'inactive' ||
                    activeTrackStatus == 'submitted'
                "
              ></b-form-input>
            </b-form-group>
            <!-- <b-form-group label="Language">
            <b-col><b-form-input
              type="text"
              required
              v-model.number="track.languages"
              placeholder="Select or Enter language"
              :disabled="
                activeTrackStatus == 'active' ||
                  activeTrackStatus == 'inactive' ||
                  activeTrackStatus == 'submitted'
              "
            ></b-form-input></b-col>
          </b-form-group> -->
            <b-form-group label="Age">
              <b-form-input
                type="number"
                required
                v-model.number="track.age"
                placeholder="Add age rating"
                :disabled="
                  activeTrackStatus == 'active' ||
                    activeTrackStatus == 'inactive' ||
                    activeTrackStatus == 'submitted'
                "
              ></b-form-input>
            </b-form-group>
            <b-form-group label="Leaning Style" class="mr-5">
              <b-form-input
                type="text"
                required
                v-model.number="track.leaningStyle"
                placeholder="Enter Learning style"
                :disabled="
                  activeTrackStatus == 'active' ||
                    activeTrackStatus == 'inactive' ||
                    activeTrackStatus == 'submitted'
                "
              ></b-form-input>
            </b-form-group>
            <b-form-group label="Copyright">
              <b-form-input
                type="text"
                required
                v-model.number="track.copyright"
                placeholder="Add copyright"
                :disabled="
                  activeTrackStatus == 'active' ||
                    activeTrackStatus == 'inactive' ||
                    activeTrackStatus == 'submitted'
                "
              ></b-form-input>
            </b-form-group>
          </b-form-row>
          <div class="mt-2 mb-2">
            <vue-taggable-select
              placeholder="Select Languages.."
              v-model="track.languages"
              :taggable="true"
              :options="languagesArray"
              ref="languages"
            ></vue-taggable-select>
          </div>

          <b-form-group label="Focus Areas">
            <div class="areas">
              <div class="spiritual">
                <h6>Spiritual</h6>
                <svg
                  @click="toggleSpheres('s')"
                  width="31"
                  height="31"
                  viewBox="0 0 31 31"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M15.5 31C24.0604 31 31 24.0604 31 15.5C31 6.93959 24.0604 0 15.5 0C6.93958 0 0 6.93959 0 15.5C0 24.0604 6.93958 31 15.5 31Z"
                    :fill="
                      track.spheres.includes('s')
                        ? 'var(--theme-color)'
                        : '#ddd'
                    "
                  />
                  <path
                    d="M16.8568 7.25651C16.7516 7.25492 16.6502 7.29588 16.5764 7.37083L14.5994 9.3367C14.5274 9.40868 14.4614 9.48604 14.395 9.56309C13.6597 8.95221 12.7373 8.60899 11.7789 8.60976H10.8973C10.6823 8.60976 10.5052 8.78694 10.5052 9.00196V10.5052H9.00191C8.78689 10.5052 8.61013 10.682 8.61013 10.897V11.7786C8.61021 12.0739 8.65073 12.3671 8.71363 12.6555C8.44879 12.8217 8.19786 13.01 7.97689 13.2314L7.3712 13.8371C7.2192 13.9891 7.2192 14.2391 7.3712 14.3911L9.36256 16.3828C9.4328 16.4531 9.50822 16.5171 9.58306 16.5816C8.95993 17.3204 8.60936 18.252 8.61013 19.2211V20.1026C8.61015 20.3176 8.78689 20.4944 9.00191 20.4944H10.5052V21.9977C10.5052 22.2127 10.6824 22.3898 10.8974 22.3898H11.7789C12.0865 22.3898 12.3914 22.3462 12.6912 22.2781C12.8553 22.5379 13.0405 22.7844 13.258 23.0017L13.8657 23.6252C13.9386 23.7001 14.0385 23.7426 14.1431 23.7434H14.1456C14.2491 23.7434 14.3487 23.7024 14.4221 23.6294L16.4001 21.6629V21.6627C16.4719 21.5906 16.5379 21.5134 16.6042 21.4363C17.3397 22.0475 18.2619 22.3907 19.2207 22.3899H20.1021C20.3172 22.3899 20.4943 22.2128 20.4943 21.9977V20.4945H21.9976C22.2127 20.4945 22.3894 20.3177 22.3894 20.1027V19.2208C22.3894 18.9255 22.3488 18.6325 22.2859 18.3442C22.5507 18.178 22.8013 17.9899 23.0223 17.7685L23.6283 17.1625C23.7804 17.0105 23.7804 16.7603 23.6283 16.6082L21.6369 14.6165C21.5667 14.5464 21.4913 14.4825 21.4165 14.418C22.0396 13.6792 22.3902 12.7477 22.3894 11.7787V10.8971C22.3894 10.6821 22.2127 10.5053 21.9976 10.5053H20.4943V9.00194C20.4943 8.78692 20.3172 8.60983 20.1021 8.60983H19.2207C18.9131 8.60986 18.6077 8.65337 18.308 8.72155C18.1442 8.46208 17.9596 8.21605 17.7425 7.99895L17.7406 7.99768L17.1329 7.37431C17.0601 7.29954 16.9602 7.25732 16.8558 7.25635L16.8568 7.25651ZM16.8489 8.20525L17.183 8.54787L17.1859 8.55072C18.4849 9.85272 18.4848 11.9568 17.1859 13.2589L16.8058 13.6389C16.5318 13.446 16.2213 13.317 15.8912 13.2591V12.7229C15.8912 11.7705 15.5541 10.8533 14.95 10.1199C15.0151 10.0417 15.0806 9.96392 15.1525 9.89192V9.89165L16.8489 8.20525ZM11.2887 9.39373H11.7782C13.6175 9.39563 15.1054 10.8837 15.1074 12.723V13.2616C14.2636 13.4116 13.5855 14.0165 13.3319 14.8326C12.1048 14.3109 11.2922 13.1198 11.2887 11.7786V11.7783V9.39373ZM19.2207 9.39373H19.7105V10.5052H19.2207C19.1198 10.5053 19.0191 10.5132 18.9186 10.5206C18.8849 10.1539 18.8001 9.79533 18.67 9.45102C18.8524 9.42046 19.0356 9.39378 19.2207 9.39373V9.39373ZM9.39369 11.2888H10.5049V11.7786C10.5049 11.8708 10.5121 11.9612 10.5183 12.0518C10.1505 12.0835 9.79054 12.1665 9.4448 12.2955C9.41791 12.1242 9.39381 11.9521 9.39373 11.7786L9.39369 11.2888ZM19.2207 11.2888H21.6055V11.7786C21.6036 13.6178 20.1158 15.1056 18.2766 15.1078H17.74C17.6822 14.7777 17.5536 14.467 17.3606 14.1929L17.74 13.8135V13.8132C18.4156 13.1413 18.826 12.2534 18.917 11.3072C19.0179 11.2979 19.119 11.289 19.2203 11.2889L19.2207 11.2888ZM10.6523 12.8262C10.9054 13.7741 11.4905 14.5876 12.2922 15.1452C11.5056 15.2281 10.7597 15.5294 10.1432 16.0297C10.0654 15.9651 9.98817 15.8999 9.9165 15.8285L8.20228 14.1139L8.53112 13.785C9.09703 13.2148 9.85237 12.8789 10.652 12.8262H10.6523ZM15.5053 13.9926C15.5587 13.9932 15.6119 13.9969 15.6647 14.0032C15.8056 14.0201 15.9437 14.0567 16.0748 14.111C16.5994 14.3282 17.0029 14.8248 17.0029 15.4997C17.001 16.3309 16.3309 17.0018 15.4997 17.003C14.8248 17.003 14.3279 16.5998 14.1106 16.0752C13.8933 15.5506 13.9595 14.9141 14.4366 14.437C14.7497 14.1239 15.1316 13.9877 15.5053 13.9926V13.9926ZM20.856 14.9699H20.8561C20.9338 15.0346 21.011 15.0997 21.0827 15.1711L22.7973 16.8854L22.4681 17.2145C21.9021 17.7846 21.1468 18.1207 20.3473 18.1734C20.0942 17.2256 19.509 16.4121 18.7074 15.8544C19.494 15.7715 20.2397 15.4702 20.8563 14.9699H20.856ZM12.7226 15.8918H12.7227H13.2589C13.3168 16.2219 13.4457 16.5324 13.6386 16.8064L13.2592 17.1861C12.5834 17.858 12.1729 18.7458 12.0819 19.6921C11.9809 19.7015 11.8797 19.7103 11.7782 19.7105H9.39369V19.221C9.39559 17.3819 10.8835 15.8941 12.7226 15.8918V15.8918ZM17.6673 16.1669C18.8946 16.6887 19.7072 17.8797 19.7105 19.2211V21.6059H19.2207C17.3814 21.604 15.8935 20.116 15.8914 18.2766V17.7381C16.7354 17.5882 17.4137 16.9831 17.6673 16.1669ZM14.1929 17.3607C14.467 17.5536 14.7776 17.6825 15.1078 17.7403V18.2766C15.1078 19.2289 15.4448 20.1459 16.0486 20.8793C15.9837 20.9576 15.9183 21.0355 15.8465 21.1076L14.1503 22.7944L13.8145 22.4498C13.8145 22.4501 13.8145 22.4491 13.8145 22.4495V22.4492V22.4489C12.5134 21.1478 12.5134 19.042 13.8145 17.7409L14.1929 17.3607ZM21.5544 18.7038C21.5813 18.8752 21.6054 19.0474 21.6055 19.2211V19.7105H20.4944V19.2211C20.4944 19.1287 20.4871 19.0382 20.4809 18.9475C20.8488 18.9159 21.2085 18.8328 21.5543 18.7038H21.5544ZM12.0806 20.479C12.1143 20.8456 12.1987 21.2042 12.3288 21.5485C12.1466 21.5791 11.9635 21.6059 11.7785 21.6059H11.2888V20.4944H11.7785C11.8794 20.4943 11.9801 20.4863 12.0806 20.4789V20.479Z"
                    fill="white"
                  />
                </svg>
              </div>
              <div class="health">
                <h6>Health</h6>
                <svg
                  @click="toggleSpheres('h')"
                  width="31"
                  height="31"
                  viewBox="0 0 31 31"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M15.5 31C24.0604 31 31 24.0604 31 15.5C31 6.93959 24.0604 0 15.5 0C6.93959 0 0 6.93959 0 15.5C0 24.0604 6.93959 31 15.5 31Z"
                    :fill="track.spheres.includes('h') ? '#FF8C7D' : '#ddd'"
                  />
                  <path
                    d="M11.7163 7.92725C10.4068 7.92725 9.20456 8.45094 8.32717 9.40254C7.46019 10.343 6.98157 11.6289 6.98157 13.0251C6.98157 14.4615 7.51479 15.7744 8.66947 17.1677C9.70254 18.4142 11.1926 19.6848 12.9201 21.157C12.921 21.1577 12.922 21.1585 12.9229 21.1593C13.5122 21.6614 14.1799 22.231 14.8729 22.837C15.0462 22.9888 15.2686 23.072 15.4994 23.072C15.73 23.072 15.9527 22.9885 16.1258 22.837C16.8204 22.2295 17.4891 21.6595 18.0793 21.1566C19.8066 19.6845 21.2965 18.4139 22.3296 17.1673C23.4843 15.7741 24.0179 14.4615 24.0179 13.0251C24.0179 11.6289 23.5392 10.343 22.6722 9.40254C21.7949 8.45094 20.5925 7.92725 19.2831 7.92725C18.305 7.92725 17.4115 8.23585 16.6225 8.84606C16.2242 9.15407 15.863 9.53126 15.5441 9.97199C15.539 9.97904 15.5323 9.98476 15.5245 9.98871C15.5167 9.99267 15.5081 9.99473 15.4993 9.99473C15.4906 9.99473 15.482 9.99267 15.4742 9.98871C15.4665 9.98476 15.4597 9.97904 15.4545 9.97199C15.1358 9.53126 14.7747 9.15407 14.3766 8.84606C13.5876 8.23586 12.6941 7.92725 11.716 7.92725H11.7163ZM11.7163 8.82091C12.4902 8.82091 13.2031 9.06806 13.8299 9.55266C14.3887 9.98484 14.7755 10.5286 15.0026 10.9093C15.1085 11.0868 15.2933 11.1918 15.4997 11.1918C15.7061 11.1918 15.8909 11.0868 15.9968 10.9093C16.224 10.5286 16.6108 9.98484 17.1695 9.55266C17.7962 9.06806 18.5091 8.82091 19.283 8.82091C20.3381 8.82091 21.31 9.2429 22.0155 10.0081C22.7315 10.7849 23.1245 11.8567 23.1245 13.0251C23.1245 14.2586 22.6636 15.3649 21.6422 16.5974C20.6547 17.789 19.1921 19.0345 17.5004 20.4763C16.9078 20.9811 16.2364 21.5535 15.5347 22.1646C15.5245 22.1734 15.5116 22.1783 15.4981 22.1783C15.4847 22.1783 15.4717 22.1734 15.4616 22.1646C14.765 21.5556 14.0961 20.9849 13.5052 20.4814L13.5021 20.479C13.5011 20.4783 13.5001 20.4775 13.4992 20.4767C11.8074 19.0349 10.3445 17.789 9.35706 16.5975C8.33555 15.3649 7.87469 14.2586 7.87469 13.0252C7.87469 11.8568 8.26769 10.7849 8.98374 10.0082C9.68935 9.24293 10.661 8.82092 11.7162 8.82092L11.7163 8.82091Z"
                    fill="white"
                  />
                </svg>
              </div>
              <div class="education">
                <h6>Education</h6>
                <svg
                  @click="toggleSpheres('e')"
                  width="31"
                  height="31"
                  viewBox="0 0 31 31"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M15.5 31C24.0604 31 31 24.0604 31 15.5C31 6.93959 24.0604 0 15.5 0C6.93959 0 0 6.93959 0 15.5C0 24.0604 6.93959 31 15.5 31Z"
                    :fill="track.spheres.includes('e') ? '#F6F28B' : '#ddd'"
                  />
                  <path
                    d="M10.1106 21.1949C9.85899 21.1949 9.65503 20.9909 9.65503 20.7393V10.0889C9.65503 9.05258 10.4982 8.20947 11.5345 8.20947H20.8885C21.1401 8.20947 21.344 8.41348 21.344 8.6651V19.1446C21.344 19.3962 21.1401 19.6002 20.8885 19.6002C20.6368 19.6002 20.4328 19.3962 20.4328 19.1446V9.12073H11.5345C11.0006 9.12073 10.5663 9.55506 10.5663 10.0889V20.7393C10.5663 20.9909 10.3623 21.1949 10.1106 21.1949V21.1949Z"
                    fill="white"
                  />
                  <path
                    d="M20.8885 22.7901H11.7054C10.5748 22.7901 9.65503 21.8703 9.65503 20.7398C9.65503 19.6092 10.5748 18.6895 11.7054 18.6895H20.8885C21.1401 18.6895 21.344 18.8935 21.344 19.1451C21.344 19.3967 21.1401 19.6007 20.8885 19.6007H11.7054C11.0773 19.6007 10.5663 20.1117 10.5663 20.7398C10.5663 21.3679 11.0773 21.8788 11.7054 21.8788H20.8885C21.1401 21.8788 21.344 22.0828 21.344 22.3345C21.344 22.5861 21.1401 22.7901 20.8885 22.7901V22.7901Z"
                    fill="white"
                  />
                  <path
                    d="M20.8886 21.1954H11.7055C11.4538 21.1954 11.2499 20.9914 11.2499 20.7398C11.2499 20.4882 11.4538 20.2842 11.7055 20.2842H20.8886C21.1402 20.2842 21.3442 20.4882 21.3442 20.7398C21.3442 20.9914 21.1402 21.1954 20.8886 21.1954Z"
                    fill="white"
                  />
                  <path
                    d="M12.1611 19.6002C11.9094 19.6002 11.7054 19.3962 11.7054 19.1445V8.6651C11.7054 8.41348 11.9094 8.20947 12.1611 8.20947C12.4127 8.20947 12.6167 8.41348 12.6167 8.6651V19.1445C12.6167 19.3962 12.4127 19.6002 12.1611 19.6002Z"
                    fill="white"
                  />
                </svg>
              </div>
              <div class="finance">
                <h6>Finance</h6>
                <svg
                  @click="toggleSpheres('f')"
                  width="31"
                  height="31"
                  viewBox="0 0 31 31"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M15.5 31C24.0604 31 31 24.0604 31 15.5C31 6.93959 24.0604 0 15.5 0C6.93959 0 0 6.93959 0 15.5C0 24.0604 6.93959 31 15.5 31Z"
                    :fill="track.spheres.includes('f') ? '#65EA82' : '#ddd'"
                  />
                  <path
                    d="M11.226 8.40771C10.3024 8.41177 9.55279 9.15531 9.53763 10.0792H9.35966C8.42659 10.0792 7.6684 10.8333 7.66431 11.7664C7.66431 11.7665 7.66431 11.7666 7.66431 11.7666V20.8924C7.66431 20.8925 7.66431 20.8925 7.66431 20.8926C7.66839 21.8256 8.42237 22.5877 9.35948 22.5918H19.7737C20.6973 22.5877 21.4469 21.8441 21.4621 20.9202H21.64C22.5731 20.9202 23.3313 20.1661 23.3354 19.233C23.3354 19.233 23.3354 19.2329 23.3354 19.2328V10.107C23.3354 10.1069 23.3354 10.1068 23.3354 10.1068C23.3313 9.16996 22.5772 8.41181 21.6402 8.40772H11.226V8.40771ZM11.226 9.29902H11.2265H21.6403C22.0841 9.30298 22.4406 9.66321 22.4444 10.1073V12.0289L21.4652 13.2909V11.7666C21.4652 10.8334 20.7069 10.0792 19.7738 10.0792H10.4289C10.4437 9.64847 10.7918 9.3029 11.2261 9.29902H11.226ZM9.35948 10.9705H19.7737C20.2138 10.9705 20.5738 11.3229 20.5738 11.7666V14.0008C20.5183 14.0108 20.4625 14.0193 20.4105 14.0193H18.114C16.8385 14.0193 15.8019 15.056 15.8019 16.3315C15.8019 17.607 16.8384 18.6437 18.1139 18.6477H20.4063C20.4072 18.6477 20.4081 18.6477 20.4089 18.6477C20.4641 18.6447 20.5171 18.6383 20.5697 18.6325L20.5736 20.8925C20.5736 21.3363 20.2173 21.6965 19.7735 21.7004H9.35967H9.35921C8.91553 21.6965 8.55911 21.3363 8.55516 20.8924V11.7671V11.7666C8.55915 11.3268 8.91534 10.9705 9.35921 10.9705L9.35948 10.9705ZM22.4405 13.4856L22.4442 15.7621L21.2084 17.365C21.0186 17.6118 20.7219 17.7566 20.4099 17.7604H18.1143H18.1139C17.3277 17.7564 16.693 17.1215 16.693 16.3354C16.693 15.5494 17.3277 14.9146 18.1139 14.9106H20.4063C20.6876 14.9106 20.9652 14.8495 21.2186 14.727L21.219 14.7268C21.4886 14.6001 21.725 14.4084 21.9085 14.1718V14.1718L22.4405 13.4856ZM18.0504 15.8898C17.8055 15.8898 17.6048 16.0905 17.6048 16.3354C17.6048 16.5804 17.8055 16.7811 18.0504 16.7811H19.0055C19.2504 16.7811 19.4512 16.5804 19.4512 16.3354C19.4512 16.0905 19.2504 15.8898 19.0055 15.8898H18.0504ZM22.4443 17.219V19.2328C22.4402 19.6727 22.0841 20.0289 21.6402 20.0289H21.4651V18.3165C21.6315 18.2011 21.7833 18.0617 21.9118 17.906C21.9121 17.9056 21.9124 17.9052 21.9127 17.9048L22.4443 17.219Z"
                    fill="white"
                  />
                </svg>
              </div>
            </div>
          </b-form-group>
          <b-form-group label="SEO">
            <b-form-input
              type="text"
              required
              v-model="seo"
              placeholder="Enter SEO Tags"
              @keypress.enter.prevent="addTag"
              :disabled="
                activeTrackStatus == 'active' ||
                  activeTrackStatus == 'inactive' ||
                  activeTrackStatus == 'submitted'
              "
            ></b-form-input>
          </b-form-group>

          <div class="form-group">
            <div class="places-lived">
              <div
                class="place__places-lived"
                v-for="(seo, index) in track.seo"
                :key="index"
              >
                {{ seo }}
                <span class="ico del__ico" @click="delTag(seo)">
                  <svg
                    width="12"
                    height="12"
                    viewBox="0 0 12 12"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M1 3C1 2.72386 1.22386 2.5 1.5 2.5H10.5C10.7761 2.5 11 2.72386 11 3C11 3.27614 10.7761 3.5 10.5 3.5H1.5C1.22386 3.5 1 3.27614 1 3Z"
                      fill="#FF8C7D"
                    />
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M5 1.5C4.86739 1.5 4.74022 1.55268 4.64645 1.64645C4.55268 1.74021 4.5 1.86739 4.5 2V2.5H7.5V2C7.5 1.86739 7.44732 1.74021 7.35355 1.64645C7.25979 1.55268 7.13261 1.5 7 1.5H5ZM8.5 2.5V2C8.5 1.60217 8.34196 1.22064 8.06066 0.93934C7.77936 0.658035 7.39782 0.5 7 0.5H5C4.60218 0.5 4.22064 0.658035 3.93934 0.93934C3.65804 1.22064 3.5 1.60217 3.5 2V2.5H2.5C2.22386 2.5 2 2.72386 2 3V10C2 10.3978 2.15804 10.7794 2.43934 11.0607C2.72064 11.342 3.10217 11.5 3.5 11.5H8.5C8.89783 11.5 9.27936 11.342 9.56066 11.0607C9.84196 10.7794 10 10.3978 10 10V3C10 2.72386 9.77614 2.5 9.5 2.5H8.5ZM3 3.5V10C3 10.1326 3.05268 10.2598 3.14645 10.3536C3.24021 10.4473 3.36739 10.5 3.5 10.5H8.5C8.63261 10.5 8.75978 10.4473 8.85355 10.3536C8.94732 10.2598 9 10.1326 9 10V3.5H3Z"
                      fill="#FF8C7D"
                    />
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M5 5C5.27614 5 5.5 5.22386 5.5 5.5V8.5C5.5 8.77614 5.27614 9 5 9C4.72386 9 4.5 8.77614 4.5 8.5V5.5C4.5 5.22386 4.72386 5 5 5Z"
                      fill="#FF8C7D"
                    />
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M7 5C7.27614 5 7.5 5.22386 7.5 5.5V8.5C7.5 8.77614 7.27614 9 7 9C6.72386 9 6.5 8.77614 6.5 8.5V5.5C6.5 5.22386 6.72386 5 7 5Z"
                      fill="#FF8C7D"
                    />
                  </svg>
                </span>
              </div>
            </div>
          </div>
          <div class="tools">
            <div>
              <h6>Engines:</h6>
              <div
                class="ico"
                @click="showEngines"
                v-if="
                  activeTrackStatus !== 'active' &&
                    activeTrackStatus !== 'inactive' &&
                    activeTrackStatus !== 'submitted'
                "
              >
                <svg
                  width="28"
                  height="28"
                  viewBox="0 0 28 28"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <circle
                    cx="14"
                    cy="14"
                    r="14"
                    fill="var(--theme-color)"
                    fill-opacity="0.1"
                  />
                  <path
                    d="M14 6V22"
                    stroke="var(--theme-color)"
                    stroke-width="2"
                    stroke-linecap="round"
                  />
                  <path
                    d="M6 14L22 14"
                    stroke="var(--theme-color)"
                    stroke-width="2"
                    stroke-linecap="round"
                  />
                </svg>
              </div>
              <div
                class="engine"
                v-for="(engine, n) in track.engines && track.engines.active"
                :key="n"
              >
                {{ engine.text }}
                <svg
                  v-b-tooltip.hover
                  title="Remove Engine"
                  @click="removeEngine(n)"
                  width="10"
                  height="10"
                  viewBox="0 0 10 10"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M1 1L9 9"
                    stroke="var(--theme-color)"
                    stroke-width="1.5"
                    stroke-linecap="round"
                  />
                  <path
                    d="M9 1L1 9"
                    stroke="var(--theme-color)"
                    stroke-width="1.5"
                    stroke-linecap="round"
                  />
                </svg>
              </div>
            </div>
          </div>
          <div class="tools">
            <div>
              <h6>Tools:</h6>
              <div
                class="ico"
                @click="showTools"
                v-if="
                  activeTrackStatus !== 'active' &&
                    activeTrackStatus !== 'inactive' &&
                    activeTrackStatus !== 'submitted'
                "
              >
                <svg
                  width="28"
                  height="28"
                  viewBox="0 0 28 28"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <circle
                    cx="14"
                    cy="14"
                    r="14"
                    fill="var(--theme-color)"
                    fill-opacity="0.1"
                  />
                  <path
                    d="M14 6V22"
                    stroke="var(--theme-color)"
                    stroke-width="2"
                    stroke-linecap="round"
                  />
                  <path
                    d="M6 14L22 14"
                    stroke="var(--theme-color)"
                    stroke-width="2"
                    stroke-linecap="round"
                  />
                </svg>
              </div>
              <img
                v-for="(tool, i) in track.tools"
                :src="tool.imgURL"
                :key="i"
                :alt="tool.name"
                v-b-tooltip.hover
                :title="tool.name"
                width="30"
              />
            </div>
          </div>
          <div class="tools">
            <div>
              <h6>Guides:</h6>
              <div
                class="ico"
                @click="showGuides"
                v-if="
                  activeTrackStatus !== 'active' &&
                    activeTrackStatus !== 'inactive' &&
                    activeTrackStatus !== 'submitted'
                "
              >
                <svg
                  width="28"
                  height="28"
                  viewBox="0 0 28 28"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <circle
                    cx="14"
                    cy="14"
                    r="14"
                    fill="var(--theme-color)"
                    fill-opacity="0.1"
                  />
                  <path
                    d="M14 6V22"
                    stroke="var(--theme-color)"
                    stroke-width="2"
                    stroke-linecap="round"
                  />
                  <path
                    d="M6 14L22 14"
                    stroke="var(--theme-color)"
                    stroke-width="2"
                    stroke-linecap="round"
                  />
                </svg>
              </div>
              <img
                v-for="(guide, i) in track.guides"
                :src="guide.imgURL"
                :key="i"
                :alt="guide.name"
                v-b-tooltip.hover
                :title="guide.name"
                width="30"
              />
            </div>
          </div>
          <!-- <b-form-group label="Role" class="custom-label"> -->
          <div class="roles">
            <vue-taggable-select
              placeholder="Select Roles.."
              v-model="track.roles"
              :taggable="true"
              :options="rolesArray"
              ref="role"
            ></vue-taggable-select>
          </div>
          <!-- </b-form-group> -->
          <!-- <div class="tools">
            <div>
              <h6>Connections:</h6>
              <div
                class="ico"
                @click="showConnections"
                v-if="
                  activeTrackStatus !== 'active' &&
                    activeTrackStatus !== 'inactive' &&
                    activeTrackStatus !== 'submitted'
                "
              >
                <svg
                  width="28"
                  height="28"
                  viewBox="0 0 28 28"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <circle
                    cx="14"
                    cy="14"
                    r="14"
                    fill="var(--theme-color)"
                    fill-opacity="0.1"
                  />
                  <path
                    d="M14 6V22"
                    stroke="var(--theme-color)"
                    stroke-width="2"
                    stroke-linecap="round"
                  />
                  <path
                    d="M6 14L22 14"
                    stroke="var(--theme-color)"
                    stroke-width="2"
                    stroke-linecap="round"
                  />
                </svg>
              </div>
              <img
                v-for="(connection, i) in track.connections"
                :src="connection.imgURL"
                :key="i"
                :alt="connection.name"
                v-b-tooltip.hover
                :title="connection.name"
                width="30"
              />
            </div>
          </div> -->
          <div class="foot">
            <div class="d-flex justify-content-between">
              <b-button variant="light btn-simple" @click="cancelAction">
                Cancel
              </b-button>
              <b-button
                variant="primary btn-round-fill"
                v-if="add"
                @click="addTrack"
                :disabled="
                  //track.detail.trim().length > 0 &&
                  track.title.trim().length > 0 ? false : true
                "
              >
                Add
              </b-button>
              <b-button
                variant="primary btn-round-fill"
                @click="editTrack"
                v-else
                :disabled="
                  //track.detail.trim().length > 0 &&
                  track.title.trim().length > 0 &&
                  activeTrackStatus !== 'active' &&
                  activeTrackStatus !== 'inactive' &&
                  activeTrackStatus !== 'submitted'
                    ? false
                    : true
                "
              >
                Update
              </b-button>
            </div>
          </div>
        </div>
        <div class="add-track del-track" v-else>
          <span class="close-icon" @click="$bvModal.hide(trackModal)">
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle cx="12" cy="12" r="12" fill="#E4E6EB" />
              <g clip-path="url(#clip0)">
                <path
                  d="M12.5891 12.0006L17.2111 7.37855C17.3739 7.21582 17.3739 6.95199 17.2111 6.78928C17.0484 6.62657 16.7846 6.62655 16.6219 6.78928L11.9998 11.4113L7.37782 6.78928C7.21509 6.62655 6.95126 6.62655 6.78855 6.78928C6.62584 6.95201 6.62582 7.21584 6.78855 7.37855L11.4106 12.0006L6.78855 16.6226C6.62582 16.7853 6.62582 17.0492 6.78855 17.2119C6.8699 17.2932 6.97655 17.3339 7.0832 17.3339C7.18984 17.3339 7.29647 17.2932 7.37784 17.2119L11.9998 12.5899L16.6218 17.2119C16.7032 17.2932 16.8098 17.3339 16.9165 17.3339C17.0231 17.3339 17.1298 17.2932 17.2111 17.2119C17.3739 17.0491 17.3739 16.7853 17.2111 16.6226L12.5891 12.0006Z"
                  fill="#606770"
                />
              </g>
              <defs>
                <clipPath id="clip0">
                  <rect
                    width="10.6667"
                    height="10.6667"
                    fill="white"
                    transform="translate(6.6665 6.66675)"
                  />
                </clipPath>
              </defs>
            </svg>
          </span>
          <h3>Delete Track</h3>
          <div class="warning-msg">
            <p>
              Are you sure want to delete
              <strong>{{ tracks[this.activeIndex].title }}</strong> track?
            </p>
          </div>
          <div class="d-flex justify-content-between">
            <b-button class="danger btn-round-fill" @click="deleteTrack">
              Yes! Delete
            </b-button>
            <b-button class="btn-simple" @click="hideDeleteTrack">
              No! back
            </b-button>
          </div>
        </div>
      </modal>
      <vimeo-modal
        v-if="activeVideo"
        :id="bloggerTrackVideo"
        :videoId="activeVideo.videoId"
        :videoThumb="activeVideo.videoThumb ? activeVideo.videoThumb : null"
      ></vimeo-modal>
    </div>
    <Tools @updateTools="updateTools($event)" :key="refresh" />
    <Guides @updateGuides="updateGuides($event)" :key="refresh + 1" />
    <!-- <Connections
      @updateConnections="updateConnections($event)"
      :key="refresh + 2"
    /> -->
    <Engines
      v-if="showEngine"
      @closeMe="updateEngines($event)"
      :key="refresh + 3"
      :oldEngines="this.engines"
      :addedEgines="this.addedEgines"
    />
    <dashcard
      @close-dashcard="hideTrackModal"
      :focus="this.trackPassing"
      @saveVideosToAT="saveVideosToAT"
    />
  </div>
</template>

<script>
import firebase from "firebase";
import Tools from "../_focus/tools";
import Guides from "../_focus/guides";
import Connections from "../_focus/connections";
import Modal from "@/components/common/modal";
import Dashcard from "@/components/dashcard/TrackDashcard";
import vimeoModal from "@/components/common/vimeoModal";
import VideoHandling from "@/mixins/VideoHandling";
import MixinLanguages from "@/mixins/abouts/Languages";
import Engines from "../_focus/engines";
import Editor from "../../editor";
import MyUpload from "vue-image-crop-upload";
import UploadImage from "@/mixins/UploadImage";
import Roles from "@/mixins/lists/Roles";
// import VueMultiSelect from "vue-simple-multi-select";
import VueTaggableSelect from "../_multiselect/VueTaggableSelect";

export default {
  data() {
    return {
      fetching: false,
      trackModal: "track-modal",
      bloggerTrackVideo: "activation-track-video",
      refresh: 1,
      showCard: false,
      add: true,
      del: false,
      activeIndex: -1,
      activeCollapse: -1,
      isJustShown: false,
      searchStr: "",
      clear: false,
      trackContent: {},
      seo: "",
      asset: "",
      popupText: "Copy to clipboard",
      uploadingImage: false,
      activeImage: "",
      imgDataUrl: "",
      imgURL: "",
      trackPassing: {},
      track: {
        title: "",
        detail: {},
        seo: [],
        spheres: [],
        tools: [],
        guides: [],
        engines: [],
        connections: [],
        imgURL: "",
        weeks: 0,
        roles: null,
        price: 0,
        categories: "",
        languages: null,
        age: 3,
        leaningStyle: "",
        Copyright: ""
      },
      rolesArray: [],
      languagesArray: [],
      activeVideo: null,
      processingVideo: false,
      selectedTrack: null,
      activeTrackStatus: null,
      activeTrack: null,
      listTracks: [],
      allTracks: [],
      engines: [],
      addedEgines: [],
      oldEngines: [],
      showEngine: false,
      showUpload: false,
      uploadingScreen: false,
      currIndex: "",
      params: {
        token: "123456798",
        name: "avatar"
      },
      headers: {
        smail: "*_~"
      }
    };
  },
  components: {
    Modal,
    Tools,
    Guides,
    vimeoModal,
    Connections,
    Editor,
    Engines,
    MyUpload,
    Roles,
    MixinLanguages,
    VueTaggableSelect,
    Dashcard
  },
  props: {
    profile: {
      type: Object,
      default: () => {}
    }
  },
  mixins: [UploadImage, VideoHandling],
  beforeMount() {
    this.fetching = true;
  },
  mounted() {
    this.getTracks();
    this.$root.$on("bv::collapse::state", (collapseId, isJustShown) => {
      if (this.activeCollapse == collapseId) {
        this.activeCollapse = -1;
      }

      if (isJustShown) {
        this.activeCollapse = collapseId;
      }
    });
    this.setRolesArray();
    this.setLanguagesArray();
    this.$store.dispatch("user/getListNames");
    this.$store.dispatch("user/getListRoles");
    // this.$store.dispatch("user/getListEngines");
  },
  computed: {
    tracks() {
      if (this.searchStr.trim() == "") return this.allTracks;

      return this.allTracks.filter(track => {
        return track.title
          .toLowerCase()
          .includes(this.searchStr.toLowerCase().trim());
        //    ||
        // track.detail
        //   .toLowerCase()
        //   .includes(this.searchStr.toLowerCase().trim())
      });
    }
  },
  watch: {
    // trackContent(val) {
    //   if (val) {
    //     return val;
    //   }
    // }
  },
  methods: {
    saveVideosToAT(videos, name) {
      this.saveTubeviewToolData(videos);
      // console.log('kaisa raha safar jane meri janaman baspan ka pyar mera bhol ni jana ray', name)
    },
    setRolesArray() {
      this.$typeAheadRolesData.forEach(e => this.rolesArray.push(e.text));
    },
    handleViewClick(track, index) {
      console.log("here => ", index);
      // this.showDashCard = true;
      this.trackPassing = track;
      this.showCard = true;
      this.$bvModal.show(`dashcard-${track.id}`);
    },
    hideTrackModal(id) {
      this.$bvModal.hide(`dashcard-${id}`);
    },
    setLanguagesArray() {
      this.$typeAheadAboutsLanguage.forEach(e =>
        this.languagesArray.push(e.text)
      );
    },
    getNumWeek(e) {
      this.track.weeks = Math.ceil(e);
    },
    cropSuccess(imgDataUrl) {
      this.handleUploadImage(imgDataUrl);
    },
    cropUploadSuccess(jsonData, field) {
      console.log(jsonData);
      console.log("field: " + field);
    },
    cropUploadFail(status, field) {
      console.log(status);
      console.log("field: " + field);
    },
    resetClear() {
      this.clear = false;
    },
    input(val) {
      this.track.detail = val.content;
    },
    getTracks() {
      this.allTracks = [];
      this.$store
        .dispatch("user/getListTracks")
        .then(data => {
          console.log(data);
          if (data.length > 0) {
            this.allTracks = data;
          }
          this.fetching = false;
        })
        .catch(error => {
          this.$nprogress.done();
          this.$store.dispatch("user/showNotification", {
            title: error.code,
            description: error.message,
            variant: "danger"
          });
          this.fetching = false;
        });
    },
    getTrackStats(event, track) {
      if (event.target.getAttribute("aria-expanded") == "true") {
        if (track.status == "active") {
          this.activeTrack = null;
          let existingTrack = this.listTracks.filter(
            lTrack => lTrack.id === track.id
          );
          if (existingTrack.length == 0) {
            this.$store
              .dispatch("listings/getListActivationTrack", track.id)
              .then(data => {
                this.activeTrack = data;
                console.log("this.activeTrack => ", this.activeTrack);
                this.listTracks.push(data);
              })
              .catch(error => {
                console.log("Error getting document: ", error);
              });
          } else {
            this.activeTrack = existingTrack[0];
          }
          this.getThumbnail(track);
        }
      } else return;
    },
    getThumbnail(track) {
      if (track.video && !track.video.videoThumb) {
        this.selectedTrack = track;
        this.processingVideo = true;
        this.getVideoThumbnail(track.video.videoId).then(thumbnail => {
          this.$store
            .dispatch("user/updateTrackVideoThumbnail", {
              id: track.id,
              thumbnail
            })
            .then(res => {
              this.$store.dispatch("user/getListTracks").then(data => {
                this.allTracks = data;
                this.processingVideo = false;
              });
            });
        });
      }
    },
    copytoClipboard(link) {
      //maybe move to mixin
      navigator.clipboard.writeText(link);
      this.popupText = "Copied!";
    },
    changePopupText() {
      setTimeout(() => {
        this.popupText = "Copy to clipboard";
      }, 300);
    },
    getStatus(status) {
      if (status == "draft") {
        return "Draft";
      } else if (status == "submitted") {
        return "Submitted";
      } else if (status == "need_work") {
        return "Needs Work";
      } else if (status == "inactive") {
        return "Removed";
      } else if (status == "active") {
        return "Published";
      }
    },
    getStatusColor(status) {
      if (status == "draft") {
        return "#C0C0C0";
      } else if (status == "submitted") {
        return "var(--theme-color)";
      } else if (status == "need_work") {
        return "#FFCC00";
      } else if (status == "inactive") {
        return "#FF0000";
      } else if (status == "active") {
        return "#4BB543";
      }
    },
    addTag() {
      if (this.seo.trim() == "") return;
      this.track.seo.unshift(this.seo);
      this.seo = "";
    },
    delTag(tag) {
      let index = this.track.seo.indexOf(tag);
      if (index > -1) {
        this.track.seo.splice(index, 1);
      }
    },
    toggleSpheres(e) {
      if (this.track.spheres.includes(e)) {
        let index = this.track.spheres.indexOf(e);
        this.track.spheres.splice(index, 1);
      } else {
        this.track.spheres.push(e);
      }
    },
    showAddTrack() {
      this.del = false;
      this.add = true;
      this.resetForm();
      this.$bvModal.show(this.trackModal);
    },
    addTrack() {
      let track = {
        id: `track_${this.getTrackId(20)}`,
        _created_at: new Date(),
        status: "draft",
        title: this.track.title,
        detail: this.track.detail,
        spheres: this.track.spheres,
        seo: this.track.seo,
        tools: this.track.tools,
        guides: this.track.guides,
        connections: this.track.connections,
        engines: this.track.engines,
        weeks: this.track.weeks,
        price: this.track.price,
        roles: this.track.roles,
        categories: this.track.categories,
        languages: this.track.languages,
        age: this.track.age,
        leaningStyle: this.track.leaningStyle,
        copyright: this.track.copyright,
        imgURL: "",
        docURL:
          "https://docs.google.com/document/d/1-cWV93kx0DowfPO_7UpR4ukkcAta6h0FeOJKMcnwKjQ/edit"
      };
      this.$store.dispatch("user/createTrack", track).then(res => {
        if (res) {
          this.$bvModal.hide(this.trackModal);
          this.resetForm();
          this.getTracks();
          this.$store.dispatch("user/showNotification", {
            title: "Tracks Updated Successfully",
            description: "The Track has been updated",
            variant: "success"
          });
        }
      });
    },
    showEditTrack(i) {
      this.del = false;
      this.add = false;
      this.activeIndex = i;
      this.activeTrackStatus = this.tracks[i].status;
      this.track.title = this.tracks[i].title;
      this.track.detail = this.tracks[i].detail;
      this.track.spheres = this.tracks[i].spheres;
      this.track.seo = this.tracks[i].seo;
      this.track.tools = this.tracks[i].tools;
      this.track.guides = this.tracks[i].guides;
      this.track.connections = this.tracks[i].connections;
      this.trackContent = this.tracks[i].detail[0];
      this.track.engines = this.tracks[i].engines;
      this.engines = this.tracks[i].engines && this.tracks[i].engines.active;
      this.addedEgines = this.tracks[i].engines && this.tracks[i].engines.all;
      this.track.weeks = this.tracks[i].weeks;
      this.track.price = this.tracks[i].price;
      this.track.roles = this.tracks[i].roles;
      (this.track.categories = this.tracks[i].categories),
        (this.track.languages = this.tracks[i].languages),
        (this.track.age = this.tracks[i].age),
        (this.track.leaningStyle = this.tracks[i].leaningStyle),
        (this.track.copyright = this.tracks[i].copyright),
        setTimeout(() => {
          this.tracks[i].roles &&
            this.tracks[i].roles.forEach(e =>
              this.$refs.role.selectedOptions.push(e)
            );
        }, 1000);
      setTimeout(() => {
        this.tracks[i].languages &&
          this.tracks[i].languages.forEach(e =>
            this.$refs.languages.selectedOptions.push(e)
          );
      }, 1000);
      this.$bvModal.show(this.trackModal);
    },
    editTrack() {
      let track = {
        id: this.tracks[this.activeIndex].id,
        title: this.track.title,
        detail: this.track.detail,
        spheres: this.track.spheres,
        seo: this.track.seo,
        tools: this.track.tools,
        guides: this.track.guides,
        engines: this.track.engines,
        connections: this.track.connections,
        weeks: this.track.weeks,
        price: this.track.price,
        roles: this.track.roles,
        categories: this.track.categories,
        languages: this.track.languages,
        age: this.track.age,
        leaningStyle: this.track.leaningStyle,
        copyright: this.track.copyright,
        imgURL: ""
      };
      this.$store.dispatch("user/updateTrack", track).then(res => {
        if (res) {
          this.$bvModal.hide(this.trackModal);
          this.resetForm();
          this.getTracks();
          this.$store.dispatch("user/showNotification", {
            title: "Tracks Updated Successfully",
            description: "Awesome",
            variant: "success"
          });
        }
      });
    },
    showDeleteTrack(i) {
      this.del = true;
      this.activeIndex = i;
      this.$bvModal.show(this.trackModal);
    },
    deleteTrack() {
      let track = this.tracks[this.activeIndex];
      this.$store.dispatch("user/deleteTrack", track).then(res => {
        if (res) {
          this.$bvModal.hide(this.trackModal);
          this.getTracks();
          this.del = false;
          this.$store.dispatch("user/showNotification", {
            title: "Tracks Updated Successfully",
            description: "Awesome",
            variant: "success"
          });
        }
      });
    },
    hideDeleteTrack() {
      this.$bvModal.hide(this.trackModal);
    },
    cancelAction() {
      this.resetForm();
      this.$bvModal.hide(this.trackModal);
      this.refresh++;
    },
    getTrackId(length) {
      //move to mixin
      var result = "";
      var characters =
        "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
      var charactersLength = characters.length;
      for (var i = 0; i < length; i++) {
        result += characters.charAt(
          Math.floor(Math.random() * charactersLength)
        );
      }
      return result;
    },
    submitTrack(track) {
      let trackType = "guide";

      let owner =
        trackType === "guide"
          ? {
              firstname: this.profile.firstname,
              lastname: this.profile.lastname,
              imgURL: this.profile.imgURL,
              profileName: this.profile._dashboards.guide.profileName, //will be global
              userId: this.profile.userId
            }
          : {
              firstname: this.profile.firstname,
              lastname: this.profile.lastname,
              imgURL: this.profile.imgURL,
              profileName: this.profile._dashboards.guide.profileName,
              userId: this.profile.userId
            };

      this.$store
        .dispatch("listings/submitActivationTrack", { track, owner })
        .then(res => {
          if (res) {
            this.$store.dispatch("user/submitTrack", track).then(res => {
              this.getTracks();
              this.$store.dispatch("user/showNotification", {
                title: "Track Submitted Successfully",
                description: "You track has now been submitted for Review",
                variant: "success"
              });
            });
          }
        });
    },
    resetForm() {
      this.track = {
        title: "",
        detail: "",
        seo: [],
        spheres: [],
        tools: [],
        guides: [],
        connections: [],
        engines: [],
        imgURL: "",
        roles: null,
        weeks: 0,
        price: 0,
        categories: "",
        languages: [],
        age: 3,
        leaningStyle: "",
        copyright: ""
      };
      this.seo = "";
      this.activeIndex = null;
      this.activeTrackStatus = null;
      this.trackContent = {};
    },
    showTools() {
      this.$bvModal.show("blog-tools");
    },
    showEngines() {
      this.showEngine = true;
      this.$bvModal.show("blog-engines");
    },
    updateTools(tools) {
      this.track.tools = tools;
    },
    showGuides() {
      this.$bvModal.show("blog-guides");
    },
    updateGuides(guides) {
      this.track.guides = guides;
    },
    showConnections() {
      this.$bvModal.show("blog-connections");
    },
    updateConnections(connections) {
      this.track.connections = connections;
    },
    updateEngines(engines) {
      this.track.engines = engines;
      this.showEngine = false;
    },
    handleAudioClick(track) {
      console.log(track);
    },
    handleVideoClick(track) {
      if (!track.video) {
        this.selectedTrack = track;
        this.triggerChooseVideo();
      } else {
        console.log("yes");
        this.activeVideo = track.video;
        this.$bvModal.show(this.bloggerTrackVideo);
      }
    },
    triggerChooseVideo() {
      document.getElementById("blogger-track-video").click();
    },
    triggerChooseImage() {
      document.getElementById("guide-track-image").click();
    },
    uploadBloggerTrackVideo(event) {
      let file = event.target.files[0];
      let name = `activation_track_${this.profile.userId}_${(Date.now() /
        1000) |
        0}`;
      let description = `${this.profile.firstname}'s activation Track Video.`;
      this.uploadVideo(file, name, description).then(video => {
        this.saveVideo(video);
      });
    },
    async uploadScreen(i) {
      this.currIndex = i;
      console.log(this.currIndex);
      this.$refs.myupload.step = 1;
      this.showUpload = true;
    },
    handleUploadImage(imgDataUrl) {
      this.uploadingScreen = true;
      this.uploadJATImage(imgDataUrl)
        .then(imgURL => {
          this.uploadingScreen = false;
          // this.formTool.images.push(imgURL);
          this.addTrackImage(imgURL, this.currIndex);
        })
        .catch(e => {
          this.uploadingScreen = false;
        });

      return;
    },
    addTrackImage(url, i) {
      let track = {
        id: this.tracks[i].id ? this.tracks[i].id : "",
        title: this.tracks[i].title ? this.tracks[i].title : "",
        detail: this.tracks[i].detail ? this.tracks[i].detail : {},
        spheres: this.tracks[i].spheres ? this.tracks[i].spheres : [],
        seo: this.tracks[i].seo ? this.tracks[i].seo : [],
        tools: this.tracks[i].tools ? this.tracks[i].tools : [],
        guides: this.tracks[i].guides ? this.tracks[i].guides : [],
        engines: this.tracks[i].engines ? this.tracks[i].engines : [],
        connections: this.tracks[i].connections,
        weeks: this.tracks[i].weeks,
        price: this.tracks[i].price,
        roles: this.tracks[i].roles,
        categories: this.tracks[i].categories,
        languages: this.tracks[i].languages,
        age: this.tracks[i].age,
        leaningStyle: this.tracks[i].leaningStyle,
        copyright: this.tracks[i].copyright,

        imgURL: url
      };
      this.$store.dispatch("user/updateTrack", track).then(res => {
        if (res) {
          this.$bvModal.hide(this.trackModal);
          this.resetForm();
          this.getTracks();
          this.$store.dispatch("user/showNotification", {
            title: "Tracks Updated Successfully",
            description: "Awesome",
            variant: "success"
          });
        }
      });
    },
    saveVideo({ videoName, vimeoURL, videoId, vimeoName }) {
      this.processingVideo = true;
      let data = {
        id: this.selectedTrack.id,
        video: {
          _created_at: new Date(),
          videoName,
          vimeoURL,
          videoId,
          vimeoName
        }
      };
      this.$store
        .dispatch("user/addTrackVideo", data)
        .then(res => {
          this.selectedTrack.video = data.video;
          this.getVideoThumbnail(videoId).then(thumbnail => {
            this.$store
              .dispatch("user/updateTrackVideoThumbnail", {
                id: data.id,
                thumbnail
              })
              .then(res => {
                this.selectedTrack.video.videoThumb = thumbnail;
                this.processingVideo = false;
                this.$store.dispatch("user/showNotification", {
                  title: "Video Added",
                  description: "Your video has been successfully added.",
                  variant: "success"
                });
              });
          });
        })
        .catch(e => {
          this.processingVideo = false;
          this.getTracks();
          console.log(e);
        });
    },
    saveTubeviewToolData(videos) {
      let ToolName =
        videos[0] && videos[0].name ? videos[0].name : videos.toolName;
      delete videos["toolName"];
      let data = {
        id: this.trackPassing.id,
        name: ToolName,
        video: {
          _created_at: new Date(),
          videos
        }
      };
      this.$store
        .dispatch("user/saveTubeviewToolData", data)
        .then(res => {
          console.log("res => ", res);
          // this.trackPassing.tools = data.video;
          this.$store.dispatch("user/showNotification", {
            title: "Videos Added to Tool",
            description: "Your videos has been successfully added to tool.",
            variant: "success"
          });
          this.getTracks();
          // this.getVideoThumbnail(videoId).then(thumbnail => {
          //   this.$store
          //     .dispatch("user/updateTrackVideoThumbnail", {
          //       id: data.id,
          //       thumbnail
          //     })
          //     .then(res => {
          //       this.selectedTrack.video.videoThumb = thumbnail;
          //       this.processingVideo = false;
          //       this.$store.dispatch("user/showNotification", {
          //         title: "Video Added",
          //         description: "Your video has been successfully added.",
          //         variant: "success"
          //       });
          //     });
          // });
        })
        .catch(e => {
          this.getTracks();
          console.log(e);
        });
    },
    trimStr(str, len) {
      if (str.length <= len) return str;
      else return str.substr(0, len) + "...";
    }
  }
};
</script>

<style lang="scss" scoped>
.track-foot {
  display: flex;
  justify-content: space-between;
  .stats {
    display: flex;
    align-items: center;
    .ico {
      margin: 0 17px;
    }
  }
  .collapse-foot {
    display: flex;
    justify-content: flex-end;
    .btn-simple-primary {
      background-color: #fff;
      font-style: normal;
      font-weight: 600;
      font-size: 14px;
      line-height: 19px;
      justify-content: center;
      padding: 8px 16px;
      border: none;
      display: flex;
      letter-spacing: 0.05em;
      align-items: center;
      color: var(--theme-color);
      margin-left: 16px;
      border-radius: 4px;
      transition: all 0.2s ease-in-out;
      svg {
        margin-right: 16px;
      }
      &:hover {
        background-color: #f3f6f9;
      }
      &.btn-start {
        background-color: #f3f6f9;
        &:hover {
          background-color: #dfdfdf;
          box-shadow: 0px 0px 4px 0px #eee;
        }
      }
    }
  }
}

.areas {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin-left: 25%;
  & > div {
    width: 60px;
    h6 {
      font-style: normal;
      font-weight: normal;
      font-size: 12px;
      line-height: 16px;
      color: #8d99a0;
    }
    svg {
      cursor: pointer;
    }
  }
}
.small-check {
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 19px;
  color: #8d99a0;
  margin-left: 24px;
}
.custom-control-label {
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 22px;
  color: #474d52;
}
.bv-no-focus-ring {
  position: relative;
  .pre {
    position: absolute;
    left: 15px;
    top: 50%;
    transform: translateY(-50%);
    color: #8d99a0;
  }
  .post {
    position: absolute;
    right: 15px;
    top: 50%;
    color: #8d99a0;
    transform: translateY(-50%);
  }
  input {
    padding-left: 30px;
  }
}
.add-tracks {
  font-style: normal;
  font-weight: bold;
  font-size: 14px;
  line-height: 19px;
  color: var(--theme-color);
  cursor: pointer;
  position: relative;
}
.add-track {
  .foot {
    margin-top: 24px;
    border-top: 1px solid #dddddd;
    padding: 24px 0 10px 0;
  }
  .close-icon {
    position: absolute;
    top: 24px;
    right: 20px;
    cursor: pointer;
  }
  .btn-round-fill {
    max-width: 160px;
    width: 100%;
  }
  h3 {
    margin-bottom: 0;
    margin-top: 10px;
    font-style: normal;
    font-weight: 600;
    font-size: 24px;
    line-height: 33px;
    color: #474d52;
    text-align: center;
  }
  .editor {
    max-width: 100%;
    width: 100%;
    .editor__content {
      .ProseMirror {
        width: 100%;
        border: none;
        box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.8);
        border-radius: 40px;
        padding-left: 30px;
        font-family: Nunito;
        font-style: normal;
        font-weight: normal;
        font-size: 14px;
        line-height: 19px;
        color: #474d52;
        background: #fff;
        border: 1px solid #ddd;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        border-radius: 32px;
        height: 44px;
        -webkit-box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.8) !important;
        box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.8) !important;
      }
    }
  }
}
.del-track {
  .warning-msg {
    margin: 24px 0;
    p {
      text-align: center;
      margin: 0;
    }
  }
  .btn-round-fill {
    background-color: #ef5c4a;
    border-color: #ef5c4a;
  }
  .btn-simple {
    color: #ef5c4a;
    font-weight: bold;
  }
}

.search {
  cursor: pointer;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 19px;
  color: #8d99a0;
}
.card-guide {
  box-shadow: none;
}
.tracks {
  margin-top: 20px;
  .card {
    border: none;
    box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.08);
    .details {
      display: flex;
      align-items: center;
      margin-bottom: 10px;
      & > div {
        margin-right: 18px;
        display: flex;
        align-items: center;
        svg {
          margin-right: 5px;
        }
      }
      .ico {
        margin: 0 17px;
        cursor: pointer;
      }
      .doc-ico {
        margin-left: 0;
      }
      .doc-link {
        color: var(--theme-color);
      }
    }
    .card-text {
      font-style: normal;
      font-weight: normal;
      font-size: 14px;
      line-height: 19px;
      display: flex;
      align-items: center;
      color: #474d52;
    }
    .status-btn {
      display: inline-block;
      margin-right: 15px;
      width: 105px;
      height: 21px;
      font-family: Nunito;
      font-style: normal;
      font-weight: normal;
      font-size: 14px;
      color: #ffffff;
      background: var(--theme-color);
      text-align: center;
      border: none;
      border-radius: 3px;
    }
  }

  .card-header {
    display: grid;
    grid-template-columns: 1fr 30px;
    align-items: center;
    padding: 0;
    .edit,
    .delete {
      display: none;
      cursor: pointer;
    }
    .btn-collapse {
      padding: 24px;
      text-align: left;
      box-shadow: none;
    }
    &.active {
      grid-template-columns: 1fr 30px 30px 30px;
      .edit,
      .delete {
        display: block;
      }
    }

    border: none;
    box-shadow: none;
    background: none;
  }
  .card-body {
    padding-top: 0;
    img {
      cursor: pointer;
      position: relative;
      // top: 50%;
      right: 4px;
      // -webkit-transform: translateY(-50%);
      // transform: translateY(-50%);
      height: 100px;
      width: 100px;
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      -webkit-box-align: center;
      -ms-flex-align: center;
      align-items: center;
      -webkit-box-pack: center;
      -ms-flex-pack: center;
      justify-content: center;
      background: rgba(85, 126, 251, 0.1);
      border-radius: 8px;
    }
    .track-description {
      left: 5px;
    }
  }
}
.places-lived {
  margin-top: 26px;
  .place__places-lived {
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 19px;
    color: #474d52;
    margin: 6px 15px;
  }
  .del__ico {
    cursor: pointer;
  }
}
.submit-btn {
  border-radius: 28px;
  width: 120px;
}
.roles {
  margin-top: 25px;
}
.tools {
  margin-top: 32px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border: 1px solid #eceff9;
  border-radius: 8px;
  padding: 12px 20px;
  position: relative;
  .extra-tools {
    position: absolute;
    top: 100%;
    width: 100%;
    left: 0;
    background-color: #fff;
    border: 1px solid #eceff9;
    border-top: 0;
    padding: 0px 11px 11px 11px;
    display: flex;
    justify-content: center;
  }
  .ico {
    cursor: pointer;
  }
  .ico,
  img {
    margin: 0 17px;
  }
  & > div {
    flex-wrap: wrap;
    display: flex;
    align-items: center;
    h6 {
      font-style: normal;
      font-weight: normal;
      font-size: 24px;
      line-height: 33px;
      color: #5b606c;
      margin: 0 10px 0 0;
    }
  }
  .engine {
    margin-top: 3px;
    background-color: rgba(85, 126, 251, 0.1);
    border-radius: 5px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 5px;
    font-family: "Nunito", sans-serif;
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    line-height: 22px;
    display: flex;
    align-items: center;
    color: var(--theme-color);
    margin-right: 7px;
    svg {
      margin-left: 5px;
      cursor: pointer;
    }
  }

  h6 {
    font-style: normal;
    font-weight: normal;
    font-size: 24px;
    line-height: 33px;
    display: inline;
    color: #5b606c;
    margin-right: 10px;
    //   margin-bottom: 0;
  }
}

.video-sec {
  margin-left: 15px;
}
.upload-btn {
  background-color: #fff;
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 19px;
  max-width: 220px;
  height: 50px;
  border: none;
  letter-spacing: 0.05em;
  align-items: center;
  color: var(--theme-color);
  margin-left: 16px;
  border-radius: 4px;
  transition: all 0.2s ease-in-out;
  display: flex;
  justify-content: center;
  align-items: center;
  .content {
    display: flex;
    #blogger-track-video {
      width: 0;
    }
    #guide-track-image {
      width: 0;
    }
    .ico {
      margin-right: 3px;
      img {
        cursor: pointer;
        position: relative;
        top: 50%;
        right: 4px;
        -webkit-transform: translateY(-50%);
        transform: translateY(-50%);
        height: 24px;
        width: 24px;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        -webkit-box-pack: center;
        -ms-flex-pack: center;
        justify-content: center;
        background: rgba(85, 126, 251, 0.1);
        border-radius: 8px;
      }
      svg {
        height: 30px;
      }
    }
    .watch-video {
      margin-top: 5px;
    }
    .btn-content {
      margin-top: 2px;
      font-family: Nunito;
      font-style: normal;
      font-size: 16px;
      line-height: 22px;
      color: var(--theme-color);
    }
  }
}
.upload-btn:focus {
  outline: none;
  box-shadow: none;
}
.description-title {
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 19px;
  color: #8d99a0;
  max-width: 354px;
  width: 100%;
  margin: 18px 0;
  cursor: pointer;
}
.half-fields {
  margin-left: 3px;
}
.fadeHeight-enter-active,
.fadeHeight-leave-active {
  transition: all 0.5s;
  max-height: 230px;
}
.fadeHeight-enter,
.fadeHeight-leave-to {
  opacity: 0;
  max-height: 0px;
  overflow: hidden;
}
</style>
